import axios from 'axios'

export default {
  // 用户计算量
  getStatisticsCapacity (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/capacity', params)
  },
  // 任务计算量
  getStatisticsTaskCapacity (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/taskCapacity', params)
  },
  // 用户注册量
  getStatisticsRegistrations (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/registrations', params)
  },
  // 分平台活跃用户统计
  getStatisticsSubmitTaskCount (params) {
    return axios.post('/api/rendering/admin/task/statistics/submitTaskCount', params)
  },
  // 资金充值
  getStatisticsFundsDetails (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/fundsDetails', params)
  },
  // 券明细：
  getStatisticsCouponDetails(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/couponDetails', params)
  },
  // 年度同比复购率统计：
  getStatisticsRepurchaseRate(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/repurchaseRate', params)
  },
  // 用户余额：
  getStatisticsUserBalance(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/userBalance', params)
  },
  // 用户计算量
  exportStatisticsCapacity (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportCapacity', params)
  },
  // 任务计算量
  exportStatisticsTaskCapacity (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportTaskCapacity', params)
  },
  // 用户注册量
  exportStatisticsRegistrations (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportRegistrations', params)
  },
  // 分平台活跃用户统计
  exportStatisticsSubmitTaskCount (params) {
    return axios.post('/api/rendering/admin/task/statistics/exportSubmitTaskCount', params)
  },
  // 资金充值
  exportStatisticsFundsDetails (params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportFundsDetails', params)
  },
  // 券明细：
  exportStatisticsCouponDetails(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportCouponDetails', params)
  },
  // 年度同比复购率统计：
  exportStatisticsRepurchaseRate(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportRepurchaseRate', params)
  },
  // 用户余额：
  exportStatisticsUserBalance(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportUserBalance', params)
  },
  // 查询充值明细
  getStatisticsRecharge(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/queryRecharge', params)
  },
  // 查询充值明细
  exportRecharge(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportRecharge', params)
  },
  // 查询业务列表
  queryAchievement(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/queryAchievement', params)
  },
  // 业绩申报确认
  achievementDeclareConfirm(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/achievementDeclareConfirm', params)
  },
  // 新增/编辑业绩
  addOrEditAchievement(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/addOrEditAchievement', params)
  },
  // 删除手动添加的业绩
  deleteAchievement(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/deleteAchievement', params)
  },
  // 财务重置
  financeReset(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/financeReset', params)
  },
  // 充值记录转业绩
  payOrderTranAchievement(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/payOrderTranAchievement', params)
  },
  // 拆分业绩
  splitAchievement(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/splitAchievement', params)
  },
  // 取消拆分业绩
  splitCancelAchievement(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/splitCancelAchievement', params)
  },
  // 导出业绩申报
  achievementDeclareExport(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/achievementDeclareExport', params)
  },
  // 获取指定用户信息
  getUserInfo(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/getUserInfo', params)
  },
  // 用户基础信息同步
  synUserInfo(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/synUserInfo', params)
  },
  // 业绩金额统计
  achievementAmountStatistics(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/achievementAmountStatistics', params)
  },
  // 业绩申报设置禁止
  getProhibitOperateFlag() {
    return axios.get('/api/rendering/admin/front/finance/achievementDeclare/getProhibitOperateFlag')
  },
  setProhibitOperateFlag(params) {
    return axios.get('/api/rendering/admin/front/finance/achievementDeclare/setProhibitOperateFlag', { params })
  },
  // 获取对帐单列表
  getIncomeVerification(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/incomeVerification', params)
  },
  // 导出对账单
  exportIncomeVerification(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/exportIncomeVerification', params)
  },
  // 导出收入计算
  exportIncomeCalculation(params) {
    return axios.post('/api/rendering/admin/statistics/exportIncomeCalculation', params)
  },
  // 更新账单备注
  addRemark(params) {
    return axios.post('/api/rendering/admin/front/finance/statistics/updateRemark', params)
  },
  // 导出卡帧列表
  exportAbnormalJobs (params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/exportAbnormalJobs', params)
  },
  // 导出租赁节点明细
  exportRentalNodeDetails (params) {
    return axios.post('/api/rendering/admin/task/leasenode/exportLeaseNodeDetails', params)
  },
  // 导出转入记录
  exportTransferRecord (params) {
    return axios.post('/api/rendering/admin/task/leasenode/exportTransferList', params)
  },
  // 导出项目涉及用户具体数据
  exportUserOfProject(params) {
    return axios.post('/api/rendering/admin/front/productResearch/exportUserOfProject', params)
  },
  // 导出问卷结果
  exportQuestionnaire(params) {
    return axios.post('/api/rendering/admin/front/productResearch/exportQuestionnaire', params)
  },
  // 卡帧上报
  exportCountAbnormalJobs(params) {
    return axios.post('/api/rendering/admin/task/abnormaljob/exportCountAbnormalJobs', params)
  },
  exportRevenueCumulative(params) {
    return axios.post('/api/rendering/admin/statistics/exportRevenueCumulative', params)
  },
  exportMiGuYunIncomeCalculation(params) {
    return axios.post('/api/rendering/admin/statistics/exportMiGuYunIncomeCalculation', params)
  },
  // 导出效果图客户端意见反馈
  exportUserFeedbackNew(params) {
    return axios.post('/api/rendering/admin/front/user/feedback/exportUserFeedbackNew', params)
  },
  // 导出动画客户端意见反馈
  exportClientFeedback(params) {
    return axios.post('/api/rendering/admin/front/user/feedback/exportClientFeedback', params)
  },
  // 检查是否可以生成应收账单
  checkIsCreateReceivable(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/checkIsCreateReceivable', params)
  },
  // 生成应收账单
  createReceivable(params) {
    return axios.post('/api/rendering/admin/front/finance/achievementDeclare/createReceivable', params)
  },
  // 根据选择收入计算时间获取快照列表
  getSnapshotList(params) {
    return axios.post('/api/rendering/admin/statistics/listSnapshots', params)
  },
  // 编辑快照
  editSnapshot(params) {
    return axios.post('/api/rendering/admin/statistics/editSnapshot', params)
  },
  // 正式租赁节点详情导出
  exportLeaseNodeDetails (params) {
    return this.exportRentalNodeDetails(params)
  },
  // 正式三方租赁节点导出，queryType: 0 列表，1 转入/转出记录
  exportThirdLeaseNodeList (params) {
    return axios.post('/api/rendering/admin/task/leasenode/exportThirdLeaseNodeList', params)
  },
}
